import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { trackingEvents } from 'modules/core/lib/Tracking'
import { useGraphQLClient } from 'modules/core/lib/graphql/provider'
import i18n from 'modules/core/lib/i18n'
import { track } from 'modules/core/lib/metrics'

import { EmptyStateLayout } from 'modules/trainings/components/EmptyStateLayout'

import image from './images/catalogAdmin.png'

export const EmptyStateAdmin = () => {
  const { navigation } = useNavigation()
  const graphQLClient = useGraphQLClient()

  useUnsafeEffect(() => {
    track(graphQLClient, trackingEvents.training.trainingRequest.goToTrainingCatalogEmptyState)
  }, [graphQLClient])

  return (
    <EmptyStateLayout>
      <Box maxWidth="s300" minWidth="s300" maxHeight="s360">
        <img src={image}></img>
      </Box>
      <Box gap="s24" maxWidth="s600" textAlign="center" alignItems="center">
        <Box gap="s8">
          <Text size="400" color="grey1000" weight="semibold">
            {i18n.t('trainings.training_catalog.empty_state_admin.title')}
          </Text>
          <Text size="300" color="grey800" weight="normal">
            {i18n.t('trainings.training_catalog.empty_state_admin.description')}
          </Text>
        </Box>
        <Button.Router to={navigation.trainings.catalog.list.selectTraining.fullPath()}>
          {i18n.t('trainings.training_catalog.empty_state_admin.cta')}
        </Button.Router>
      </Box>
    </EmptyStateLayout>
  )
}
